/* ============================================================
   AURELYS - Judge.me : francisation + nettoyage.
   1. Traduit toutes les chaines EN du widget.
   2. Retire les mentions de provenance repetees sur chaque avis.
   3. Retire les filtres photo/video devenus inutiles.
   4. Ajoute une note de provenance unique (conformite Omnibus).
   Idempotent : peut tourner plusieurs fois sans effet de bord.
   ============================================================ */
(function () {
  'use strict';

  /* Ordre important : les expressions longues passent avant les courtes. */
  var DICT = [
    /* -- provenance : supprimee au niveau de chaque avis, remplacee par
          une note unique en haut du widget (voir NOTICE ci-dessous) -- */
    [/\s*[-\u2013\u2014|(\[]?\s*Imported from AliExpress\s*[)\]]?/gi, ''],
    [/\s*[-\u2013\u2014|(\[]?\s*AliExpress Importer\s*[)\]]?/gi, ''],
    [/\s*[-\u2013\u2014|(\[]?\s*via AliExpress\s*[)\]]?/gi, ''],
    [/\s*[-\u2013\u2014|(\[]?\s*AliExpress\s*[)\]]?/gi, ''],

    /* -- en-tete -- */
    [/Customer Reviews/gi, 'Avis clients'],
    [/Customer Photos/gi, ''],
    [/Based on (\d+) reviews/gi, 'Bas\u00e9 sur $1 avis'],
    [/Based on (\d+) review/gi, 'Bas\u00e9 sur $1 avis'],
    [/No reviews yet/gi, "Aucun avis pour l'instant"],
    [/Be the first to write a review/gi, 'Soyez la premi\u00e8re personne \u00e0 laisser un avis'],

    /* -- actions -- */
    [/Write a review/gi, 'Laisser un avis'],
    [/Ask a question/gi, 'Poser une question'],
    [/Submit Review/gi, 'Envoyer mon avis'],
    [/Post Review/gi, 'Publier mon avis'],
    [/Load more/gi, "Voir plus d'avis"],
    [/Show more/gi, 'Voir plus'],
    [/Show less/gi, 'Voir moins'],
    [/Read more/gi, 'Voir plus'],
    [/\bCancel\b/gi, 'Annuler'],

    /* -- badges -- */
    [/Verified Purchase/gi, 'Achat v\u00e9rifi\u00e9'],
    [/Verified Buyer/gi, 'Acheteur v\u00e9rifi\u00e9'],
    [/Verified Reviewer/gi, 'Avis v\u00e9rifi\u00e9'],
    [/\bVerified\b/gi, 'V\u00e9rifi\u00e9'],

    /* -- tri -- */
    [/Most Recent/gi, 'Plus r\u00e9cents'],
    [/Most Helpful/gi, 'Plus utiles'],
    [/Highest Rating/gi, 'Note la plus haute'],
    [/Lowest Rating/gi, 'Note la plus basse'],
    [/Sort by/gi, 'Trier par'],
    [/\bSort\b/gi, 'Trier'],

    /* -- formulaire -- */
    [/How would you rate this (product|item)\?/gi, 'Quelle note donnez-vous \u00e0 ce produit \u003f'],
    [/Give your review a title/gi, 'Donnez un titre \u00e0 votre avis'],
    [/Write your comments here/gi, '\u00c9crivez votre avis ici'],
    [/Review Title/gi, "Titre de l'avis"],
    [/Enter your name \(public\)/gi, 'Votre pr\u00e9nom (public)'],
    [/Enter your email \(private\)/gi, 'Votre e-mail (non publi\u00e9)'],
    [/Your name/gi, 'Votre pr\u00e9nom'],
    [/Your email/gi, 'Votre e-mail'],
    [/\bRating\b/gi, 'Note'],
    [/\bName\b/gi, 'Nom'],
    [/\bEmail\b/gi, 'E-mail'],

    /* -- utilite / signalement -- */
    [/Was this helpful\?/gi, 'Cet avis vous a-t-il \u00e9t\u00e9 utile \u003f'],
    [/people found this helpful/gi, 'personnes ont trouv\u00e9 cet avis utile'],
    [/Report as Inappropriate/gi, 'Signaler'],
    [/\bReport\b/gi, 'Signaler'],

    /* -- pagination -- */
    [/\bPrevious\b/gi, 'Pr\u00e9c\u00e9dent'],
    [/\bNext\b/gi, 'Suivant'],

    /* -- divers -- */
    [/Thank you[^!.]*(review|feedback)[!.]*/gi, 'Merci pour votre avis \u0021'],
    [/\bReviews\b/g, 'avis'],
    [/\bReview\b/g, 'avis'],
    [/\breviews\b/g, 'avis'],
    [/\breview\b/g, 'avis']
  ];

  var NOTICE =
    "Comment nous collectons les avis : une partie des avis affich\u00e9s est import\u00e9e depuis notre fournisseur " +
    "et n'a pas fait l'objet d'une v\u00e9rification d'achat sur notre boutique. Les avis d\u00e9pos\u00e9s directement " +
    "sur AURELYS Paris sont publi\u00e9s sans contrepartie et ne sont ni modifi\u00e9s ni supprim\u00e9s.";

  var ATTRS = ['placeholder', 'title', 'aria-label', 'alt', 'value', 'data-original-title'];
  var MEDIA_RE = /(photo|picture|video|image)/i;

  function translate(str) {
    if (!str) return str;
    var out = str;
    for (var i = 0; i < DICT.length; i++) {
      out = out.replace(DICT[i][0], DICT[i][1]);
    }
    /* Nettoyage des residus laisses par la suppression de la provenance */
    out = out.replace(/\(\s*\)/g, '').replace(/\[\s*\]/g, '');
    out = out.replace(/[ \t]{2,}/g, ' ');
    out = out.replace(/^\s*[-\u2013\u2014|,]\s*/, '');
    out = out.replace(/\s*[-\u2013\u2014|,]\s*$/, '');
    return out;
  }

  function inWidget(node) {
    var el = node.nodeType === 1 ? node : node.parentElement;
    return !!(el && el.closest && el.closest('[class*="jdgm"]'));
  }

  function walk(root) {
    if (!root || !root.querySelectorAll) return;

    /* 1. Textes */
    var tw = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var n;
    var batch = [];
    while ((n = tw.nextNode())) {
      if (n.nodeValue && n.nodeValue.trim() && inWidget(n)) batch.push(n);
    }
    batch.forEach(function (t) {
      var next = translate(t.nodeValue);
      if (next !== t.nodeValue) t.nodeValue = next;
    });

    /* 2. Attributs */
    var els = root.querySelectorAll('[class*="jdgm"] input, [class*="jdgm"] textarea, [class*="jdgm"] button, [class*="jdgm"] a, [class*="jdgm"] select, [class*="jdgm"] [aria-label], [class*="jdgm"] [title]');
    Array.prototype.forEach.call(els, function (el) {
      ATTRS.forEach(function (a) {
        var v = el.getAttribute(a);
        if (!v) return;
        var next = translate(v);
        if (next !== v) el.setAttribute(a, next);
      });
    });

    /* 3. Options de tri liees aux medias : inutiles, on les retire */
    var opts = root.querySelectorAll('[class*="jdgm"] select option, [class*="jdgm"] .jdgm-sort-dropdown option');
    Array.prototype.forEach.call(opts, function (o) {
      var raw = (o.getAttribute('value') || '') + ' ' + (o.textContent || '');
      if (MEDIA_RE.test(raw)) o.remove();
    });

    /* 4. Cartes d'avis devenues vides (avis 100 % photo) : on les masque */
    var revs = root.querySelectorAll('.jdgm-rev');
    Array.prototype.forEach.call(revs, function (r) {
      var body = r.querySelector('.jdgm-rev__body');
      var title = r.querySelector('.jdgm-rev__title');
      var hasText = (body && body.textContent.trim()) || (title && title.textContent.trim());
      if (!hasText) r.style.display = 'none';
    });
  }

  function addNotice() {
    if (document.querySelector('.aur-jdgm-notice')) return;
    var header = document.querySelector('.jdgm-rev-widget__header');
    if (!header) return;
    var p = document.createElement('p');
    p.className = 'aur-jdgm-notice';
    p.textContent = NOTICE;
    header.appendChild(p);
  }

  function run(root) {
    walk(root || document.body);
    addNotice();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(); });
  } else {
    run();
  }

  /* Judge.me se charge en asynchrone et repeint apres chaque tri / pagination. */
  var pending = null;
  new MutationObserver(function (muts) {
    var touched = false;
    muts.forEach(function (m) {
      Array.prototype.forEach.call(m.addedNodes, function (node) {
        if (node.nodeType === 1 && (inWidget(node) || (node.querySelector && node.querySelector('[class*="jdgm"]')))) {
          touched = true;
        }
      });
    });
    if (!touched) return;
    clearTimeout(pending);
    pending = setTimeout(function () { run(); }, 60);
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* Filets de securite pour les chargements tardifs. */
  [800, 2000, 4500, 8000].forEach(function (d) { setTimeout(function () { run(); }, d); });
})();
